import request from '@/utils/request'


// 巡防问题列表
export function problemPage(params) {
  return request({
    url: '/nineTask/problemPage',
    method: 'get',
    params:params
  })
}


// 巡防问题统计
export function problemTotal(params) {
  return request({
    url: '/nineTask/problem',
    method: 'get',
    params:params
  })
}

//问题处理
export function processProblem(params) {
  return request({
    url: '/nineTask/processProblem',
    method: 'get',
    params:params
  })
}
//批量处理
export function processProblems(params) {
  return request({
    url: '/nineTask/processProblems',
    method: 'get',
    params:params
  })
}

//问题详情
export function problemDetail(params) {
  return request({
    url: '/nineTask/problemDetail',
    method: 'get',
    params:params
  })
}

//周期修改列表
export function changePeriodPage(params) {
  return request({
    url: '/nineTask/changePeriodPage',
    method: 'get',
    params:params
  })
}
//周期审核
export function changePeriodAudit(params) {
  return request({
    url: '/nineTask/changePeriodAudit',
    method: 'get',
    params:params
  })
}
//周期审核流水
export function auditLogPage(params) {
  return request({
    url: '/nineTask/auditLogPage',
    method: 'get',
    params:params
  })
}